import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Overhead%20flatlay%20photography%20of%20colorful%20sneakers%20denim%20jacket%20sunglasses%20and%20leather%20bag%20arranged%20on%20warm%20beige%20linen%20texture%20with%20eucalyptus%20branches%20soft%20morning%20sunlight%20casting%20gentle%20shadows%20minimalist%20composition%20fresh%20airy%20editorial%20style%20high%20resolution%20magazine%20quality&width=1600&height=900&seq=hero-main-march-2026&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-20 pb-16 md:pt-28 md:pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 max-w-xl">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-5">
              Structured Sourcing System
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-5">
              GTBuy Spreadsheet
            </h1>
            <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-lg">
              The smarter way to compare suppliers, track product pricing, and optimize
              your sourcing workflow. Built for dropshippers and ecommerce operators who
              need a clean, structured spreadsheet system that actually scales.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Buy It Now
              </a>
              <Link
                to="/what-is-gtbuy-spreadsheet"
                className="px-6 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Read the Guide
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="w-full max-w-md bg-background-50/10 backdrop-blur-md rounded-2xl p-6 border border-background-50/15">
              <p className="text-background-50/70 text-xs uppercase tracking-wider font-medium mb-4">
                Browse Categories
              </p>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
                  { name: "Hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
                  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
                  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
                  { name: "Pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
                  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
                  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
                  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
                  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
                  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
                ].map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-3 py-2 rounded-lg bg-background-50/10 text-background-50/85 text-xs hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap text-center"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block mt-4 text-center text-background-50/60 text-xs hover:text-background-50/90 transition-colors cursor-pointer"
              >
                View all categories on KA Spreadsheet &rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}